import React from "react";

/**
 * Two-column order layout: main + sticky summary; mobile compact summary + fixed CTA bar.
 */
export function HrOrderLayout({ children, summaryCompact, summarySidebar, mobileBar }) {
  return (
    <>
      <div className="hr-order-layout__mobile-summary">{summaryCompact}</div>
      <div className="hr-order-layout__shell">
        <div className="hr-order-layout__main">{children}</div>
        <aside className="hr-order-layout__aside" aria-label="סיכום">
          <div className="hr-order-layout__aside-sticky">{summarySidebar}</div>
        </aside>
      </div>
      {mobileBar ? <div className="hr-order-layout__mobile-bar">{mobileBar}</div> : null}
    </>
  );
}
